var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    join = _require$doc$builders.join;

var AssemblyCase = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var doc;

    if (node.default) {
      doc = concat(['default']);
    } else {
      doc = concat(['case ', path.call(_print, 'value')]);
    }

    return join(' ', [doc, path.call(_print, 'block')]);
  }
};
module.exports = AssemblyCase;